module.exports = __webpack_public_path__ + "img/20.71fbf9fa.png";